// extracted by mini-css-extract-plugin
module.exports = {"ripple-container":"ripple-loader_component_ripple-container__DiZzI","ripple":"ripple-loader_component_ripple__dt9ht"};